// extracted by mini-css-extract-plugin
export default {"dashboardPage":"DashboardPage_dashboardPage__SPCSj"};